import React, { useEffect, useState } from 'react';

export default function DeleteReasonModal({
  title = 'Confirm delete',
  message = 'Please enter a reason for deleting this record.',
  confirmLabel = 'Delete',
  deleting = false,
  onCancel,
  onConfirm,
  children,
}) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    setReason('');
  }, [title]);

  const trimmed = reason.trim();
  const canConfirm = trimmed.length > 0 && !deleting;

  return (
    <div className="modal-shell flex items-center justify-center">
      <div className="modal-panel max-w-md">
        <div className="p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-gray-700">{message}</p>
          {children}
          <div>
            <label htmlFor="delete-reason" className="block text-sm font-medium text-gray-700 mb-1">
              Reason for deletion <span className="text-red-500">*</span>
            </label>
            <textarea
              id="delete-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              maxLength={500}
              placeholder="Why are you deleting this?"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm"
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-1">{trimmed.length}/500 characters</p>
          </div>
          <p className="text-sm text-amber-600">
            This action cannot be undone. The reason will be visible when viewing deleted records.
          </p>
        </div>
        <div className="p-4 sm:p-6 border-t border-gray-200 flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={deleting}
            className="w-full sm:w-auto px-4 py-2.5 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(trimmed)}
            disabled={!canConfirm}
            className="w-full sm:w-auto px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {deleting ? 'Deleting…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
